/* Ember cart confetti — v1.0
   Fires a confetti burst when an item is added to cart.
   No dependencies. Drop into your Shopify theme as assets/ember-cart-confetti.js
   Palette uses Ember's own colorways: Jaipur Terracotta, Nilgiri Blue, Coorg Green,
   Himalayan Mist, Sage, Ocean, Wine, plus an ember-gold spark. */

(function () {
  'use strict';

  if (window.__emberConfetti) return;

  var CONFIG = {
    colors: [
      '#C0532B', // Jaipur Terracotta
      '#2F4F63', // Nilgiri Blue
      '#4F6B4A', // Coorg Green
      '#E3D9CB', // Himalayan Mist
      '#8FA08C', // Sage
      '#1F5C63', // Ocean
      '#6E2A34', // Wine
      '#E9A73C'  // Ember gold
    ],
    count: 90,          // particles per burst
    spread: 62,         // degrees either side of straight up
    velocity: 26,       // initial speed
    gravity: 0.62,
    drag: 0.955,
    lifetime: 2600,     // ms before a particle is removed
    scalar: 1,          // overall particle size multiplier
    cartPop: false,     // optional second burst at the cart icon; off by default
    zIndex: 2147483000, // above the cart drawer
    cooldown: 700       // ms between bursts, prevents double-fire
  };
  // Merchant overrides injected by the theme (Online Store > Customize > Cart Confetti).
  var __S = window.__emberConfettiSettings;
  if (__S) {
    if (typeof __S.count === 'number' && __S.count > 0) CONFIG.count = __S.count;
    if (typeof __S.scalar === 'number' && __S.scalar > 0) CONFIG.scalar = __S.scalar;
    if (__S.colors && __S.colors.length) CONFIG.colors = __S.colors;
  }

  var canvas, ctx, particles = [], raf = null, dpr = 1;
  var lastFire = 0;
  var lastPointer = null;

  var reduceMotion = window.matchMedia &&
    window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------- canvas ---------- */

  function ensureCanvas() {
    if (canvas) return;
    canvas = document.createElement('canvas');
    canvas.setAttribute('aria-hidden', 'true');
    canvas.style.cssText =
      'position:fixed;top:0;left:0;width:100%;height:100%;' +
      'pointer-events:none;z-index:' + CONFIG.zIndex + ';';
    document.body.appendChild(canvas);
    ctx = canvas.getContext('2d');
    resize();
    window.addEventListener('resize', resize, { passive: true });
  }

  function resize() {
    if (!canvas) return;
    dpr = Math.min(window.devicePixelRatio || 1, 2);
    canvas.width = window.innerWidth * dpr;
    canvas.height = window.innerHeight * dpr;
    ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
  }

  function teardown() {
    if (canvas && canvas.parentNode) canvas.parentNode.removeChild(canvas);
    canvas = null;
    ctx = null;
    raf = null;
  }

  /* ---------- particles ---------- */

  function rand(min, max) { return Math.random() * (max - min) + min; }

  function makeParticle(x, y) {
    var angle = (-90 + rand(-CONFIG.spread, CONFIG.spread)) * Math.PI / 180;
    var speed = CONFIG.velocity * rand(0.45, 1);
    var ribbon = Math.random() < 0.3;
    return {
      x: x,
      y: y,
      vx: Math.cos(angle) * speed,
      vy: Math.sin(angle) * speed,
      w: (ribbon ? rand(3, 5) : rand(6, 10)) * CONFIG.scalar,
      h: (ribbon ? rand(10, 16) : rand(5, 9)) * CONFIG.scalar,
      color: CONFIG.colors[(Math.random() * CONFIG.colors.length) | 0],
      tilt: rand(0, Math.PI * 2),
      tiltSpeed: rand(-0.22, 0.22),
      spin: rand(0.05, 0.16),
      phase: rand(0, Math.PI * 2),
      wobble: rand(0.4, 1.1),
      born: performance.now(),
      round: Math.random() < 0.18
    };
  }

  function step(now) {
    ctx.clearRect(0, 0, canvas.width, canvas.height);
    var alive = 0;

    for (var i = 0; i < particles.length; i++) {
      var p = particles[i];
      if (!p) continue;

      var age = now - p.born;
      if (age > CONFIG.lifetime || p.y > window.innerHeight + 60) {
        particles[i] = null;
        continue;
      }
      alive++;

      p.vx *= CONFIG.drag;
      p.vy = p.vy * CONFIG.drag + CONFIG.gravity;
      p.phase += 0.06;
      p.x += p.vx + Math.sin(p.phase) * p.wobble;
      p.y += p.vy;
      p.tilt += p.tiltSpeed;

      // fake 3-D flutter: the face turns away from the viewer
      var flip = Math.cos(p.tilt * 1.6);
      var fade = age > CONFIG.lifetime * 0.6
        ? 1 - (age - CONFIG.lifetime * 0.6) / (CONFIG.lifetime * 0.4)
        : 1;

      ctx.save();
      ctx.translate(p.x, p.y);
      ctx.rotate(p.tilt * p.spin * 4);
      ctx.scale(1, Math.max(Math.abs(flip), 0.12));
      ctx.globalAlpha = Math.max(fade, 0);
      ctx.fillStyle = p.color;

      if (p.round) {
        ctx.beginPath();
        ctx.arc(0, 0, p.w / 2, 0, Math.PI * 2);
        ctx.fill();
      } else {
        ctx.fillRect(-p.w / 2, -p.h / 2, p.w, p.h);
      }
      ctx.restore();
    }

    if (alive === 0) {
      particles = [];
      teardown();
      return;
    }

    if (particles.length > 400) particles = particles.filter(Boolean);
    raf = requestAnimationFrame(step);
  }

  /* ---------- public fire() ---------- */

  function fire(opts) {
    opts = opts || {};
    if (reduceMotion) return;
    if (document.hidden) return;

    var now = Date.now();
    if (!opts.force && now - lastFire < CONFIG.cooldown) return;
    lastFire = now;

    var origin = opts.origin || lastPointer || {
      x: window.innerWidth / 2,
      y: window.innerHeight * 0.62
    };

    ensureCanvas();

    var n = opts.count || CONFIG.count;
    for (var i = 0; i < n; i++) {
      particles.push(makeParticle(
        origin.x + rand(-12, 12),
        origin.y + rand(-8, 8)
      ));
    }

    // a smaller, delayed second pop reads as "it landed in the cart"
    if (!opts.single && CONFIG.cartPop) {
      var cart = cartAnchor();
      if (cart) {
        setTimeout(function () {
          if (reduceMotion) return;
          ensureCanvas();
          for (var j = 0; j < Math.round(n * 0.4); j++) {
            particles.push(makeParticle(cart.x + rand(-8, 8), cart.y + rand(-6, 6)));
          }
          if (!raf) raf = requestAnimationFrame(step);
        }, 190);
      }
    }

    if (!raf) raf = requestAnimationFrame(step);
  }

  /* ---------- where things come from ---------- */

  function cartAnchor() {
    var els = document.querySelectorAll(
      '[data-cart-icon], #cart-icon-bubble, .header__icon--cart, .js-cart-drawer-toggle, ' +
      '.cart-icon, a[href$="/cart"], a[href*="/cart?"]'
    );
    for (var i = 0; i < els.length; i++) {
      var el = els[i];
      var r = el.getBoundingClientRect();
      var visible = r.width > 0 && r.height > 0 &&
        r.top >= 0 && r.top < window.innerHeight &&
        r.left >= 0 && r.left < window.innerWidth &&
        getComputedStyle(el).visibility !== 'hidden';
      if (visible) return { x: r.left + r.width / 2, y: r.top + r.height / 2 };
    }
    return null; // no cart icon on screen — skip the second burst entirely
  }

  document.addEventListener('pointerdown', function (e) {
    var btn = e.target.closest &&
      e.target.closest('button, [type="submit"], .btn, .button, [data-add-to-cart]');
    if (!btn) { lastPointer = { x: e.clientX, y: e.clientY }; return; }
    var r = btn.getBoundingClientRect();
    lastPointer = { x: r.left + r.width / 2, y: r.top + r.height / 2 };
  }, { passive: true, capture: true });

  /* ---------- detect add-to-cart ---------- */

  function isAddUrl(url) {
    try {
      var u = new URL(String(url), location.href);
      return u.origin === location.origin && /\/cart\/add(\.js)?$/.test(u.pathname);
    } catch (e) { return false; }
  }

  // 1. fetch (Dawn, Horizon, most modern themes and most cart apps)
  var nativeFetch = window.fetch;
  if (nativeFetch) {
    window.fetch = function (input, init) {
      var url = (input && input.url) || input;
      var method = ((init && init.method) || (input && input.method) || 'GET').toUpperCase();
      var isAdd = method === 'POST' && isAddUrl(url);
      var call = nativeFetch.apply(this, arguments);
      if (isAdd) {
        call.then(function (res) {
          if (res && res.ok) fire();
          return res;
        }).catch(function () {});
      }
      return call;
    };
  }

  // 2. XMLHttpRequest (older themes, some upsell apps)
  var xhrOpen = XMLHttpRequest.prototype.open;
  var xhrSend = XMLHttpRequest.prototype.send;
  XMLHttpRequest.prototype.open = function (method, url) {
    this.__emberAdd = String(method).toUpperCase() === 'POST' && isAddUrl(url);
    return xhrOpen.apply(this, arguments);
  };
  XMLHttpRequest.prototype.send = function () {
    if (this.__emberAdd) {
      this.addEventListener('load', function () {
        if (this.status >= 200 && this.status < 300) fire();
      });
    }
    return xhrSend.apply(this, arguments);
  };

  // 3. Non-AJAX form post (full page reload themes) — flag it, fire on next load
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form || !form.action || !isAddUrl(form.action)) return;
    if (e.defaultPrevented) return; // theme handled it via AJAX, hooks above will catch it
    try { sessionStorage.setItem('ember:confetti', '1'); } catch (err) {}
  }, false);

  // 4. Theme pub/sub events, as a safety net for themes that bypass fetch
  ['cart:added', 'cart:add', 'product:added', 'ajaxProduct:added']
    .forEach(function (evt) {
      document.addEventListener(evt, function () { fire(); });
    });

  function boot() {
    try {
      if (sessionStorage.getItem('ember:confetti')) {
        sessionStorage.removeItem('ember:confetti');
        setTimeout(function () { fire({ force: true }); }, 260);
      }
    } catch (e) {}
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  window.__emberConfetti = { fire: fire, config: CONFIG };
})();
